var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconMeta = function SvgIconMeta(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 100,
    viewBox: "0 0 101 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.333374 16C0.333374 7.16345 7.49682 0 16.3334 0H84.3334C93.1699 0 100.333 7.16344 100.333 16V84C100.333 92.8366 93.1699 100 84.3334 100H16.3334C7.49682 100 0.333374 92.8366 0.333374 84V16Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2009_3405)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.9128 56.7068C24.9128 59.1257 25.4492 60.975 26.1502 62.0964C26.5238 62.7349 27.0618 63.2643 27.7095 63.6308C28.3573 63.9973 29.0917 64.1879 29.8381 64.1832C31.6408 64.1832 33.29 63.7435 36.4682 59.3983C39.0143 55.9174 42.0145 51.0423 44.0353 47.9638L47.4539 42.7742C49.8286 39.1702 52.5728 35.1637 55.7288 32.4392C58.2993 30.2314 61.0747 29 63.8679 29C68.5572 29 73.0241 31.6849 76.4426 36.7205C80.1839 42.2355 82.0067 49.182 82.0067 56.3506C82.0067 60.6121 81.1565 63.7435 79.7098 66.2173C78.3144 68.6097 75.5813 71 70.9987 71V64.1832C74.9225 64.1832 75.8951 60.6209 75.8951 56.5441C75.8951 50.7345 74.5241 44.2871 71.504 39.6803C69.3607 36.4127 66.5831 34.416 63.5273 34.416C60.2223 34.416 57.5627 36.8788 54.5737 41.2702C52.9846 43.6032 51.3532 46.4465 49.5215 49.6548L47.5051 53.1731C43.4544 60.2691 42.4284 61.8853 40.4031 64.5527C36.8599 69.2408 33.8286 71 29.8381 71C25.1042 71 22.1107 68.9748 20.2679 65.9226C18.7434 63.4356 18 60.1724 18 56.4539L24.9128 56.7068Z",
    fill: "#0081FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4506 37.2021C26.6198 32.3754 31.1935 29 36.4393 29C39.4773 29 42.4974 29.8796 45.6511 32.4326C49.1009 35.2142 52.7731 39.7947 57.3646 47.3437L59.0093 50.0528C62.9798 56.5881 65.2411 59.9481 66.5609 61.5357C68.2612 63.5719 69.4542 64.1744 70.9988 64.1744C74.9225 64.1744 75.8951 60.6121 75.8951 56.5353L81.9933 56.3462C81.9933 60.6077 81.1431 63.7391 79.6965 66.2129C78.3144 68.6097 75.5813 71 70.9988 71C68.15 71 65.6261 70.3887 62.8352 67.7873C60.6897 65.7907 58.1814 62.2438 56.2518 59.0553L50.5119 49.5822C47.632 44.8281 44.9901 41.2834 43.4611 39.6869C41.8142 37.9519 39.7021 35.8673 36.328 35.8673C33.5972 35.8673 31.2781 37.7606 29.3373 40.6566L23.4506 37.2021Z",
    fill: "url(#paint0_linear_2009_3405)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.328 35.8673C33.5972 35.8673 31.2781 37.7606 29.3373 40.6566C26.5931 44.7489 24.9128 50.8444 24.9128 56.7068C24.9128 59.1257 25.4492 60.975 26.1502 62.0964L20.2568 65.9226C18.7434 63.4356 18 60.1724 18 56.4539C18 49.6921 19.8784 42.6445 23.4505 37.2021C26.6198 32.3754 31.1935 29 36.4393 29L36.328 35.8673Z",
    fill: "url(#paint1_linear_2009_3405)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2009_3405",
    x1: 31.8745,
    y1: 48.9115,
    x2: 75.9391,
    y2: 51.164,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0064E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#0064E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#0073EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0082FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2009_3405",
    x1: 27.2185,
    y1: 59.5654,
    x2: 27.2185,
    y2: 43.5131,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0082FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0064E0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2009_3405"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 42,
    fill: "white",
    transform: "translate(18 29)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconMeta);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_meta.70b3a51bf05332aba8f09a1dc96642ba.svg";